import Marionette from 'backbone.marionette';

export default Marionette.Region.extend( {
   onShow: function ( region, view, options = {timeout: 5000} ) {
      setTimeout( () => view.$el.find( '.alert' ).alert( 'close' ), options.timeout );
   },
} );